export default __webpack_public_path__ + "static/media/missao.a0786a99.svg";